import { useCallback } from 'react';

/**
 * Custom hook to handle 401 authentication errors consistently across all pages
 * @returns {Function} handleAuthError - Function to handle API errors and redirect on 401
 */
const useAuthErrorHandler = () => {
    const handleAuthError = useCallback((error) => {
        // Check if it's a 401 error
        if (error.response && error.response.status === 401) {
            // Clear token and redirect to homepage (which will show login)
            localStorage.removeItem('authToken');
            window.location.href = '/';
            return true; // Indicates that the error was handled (redirected)
        }
        return false; // Indicates that the error was not a 401 and should be handled normally
    }, []);

    return handleAuthError;
};

export default useAuthErrorHandler;
